import { useMelwaysLink } from '@seek/melways-react';
import type { Language } from '@seek/melways-sites';
import {
  CUSTOMER_SERVICE_PHONE_NUMBER,
  EMPLOYER_CONTACT_US_URL,
} from '@seek/shared-constants';
import { Box } from 'braid-design-system';
import type React from 'react';

import { asiaSites } from 'src/App/constants/sites';
import { useAppContext } from 'src/App/context/AppContext';

import ErrorSection from './ErrorSection';

const GenericErrorSection: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { site, language } = useAppContext();
  const localize = useMelwaysLink();

  const isAnzSite = (
    siteName: string,
  ): siteName is keyof typeof CUSTOMER_SERVICE_PHONE_NUMBER =>
    Object.keys(CUSTOMER_SERVICE_PHONE_NUMBER).includes(siteName);

  if (isAnzSite(site)) {
    const contactNumber = CUSTOMER_SERVICE_PHONE_NUMBER[site];
    const errorLines = [
      'Unfortunately, something has gone wrong at our end.',
      `Please try again later, or contact Customer Service on ${contactNumber}.`,
    ];
    return (
      <Box data={{ role: 'GenericErrorSection' }}>
        <ErrorSection texts={errorLines} />
      </Box>
    );
  }

  if (asiaSites.includes(site)) {
    const errorLines = ['Unfortunately, something has gone wrong at our end.'];

    const contactUsLink = localize({
      path: EMPLOYER_CONTACT_US_URL[site],
      language: language as Language,
    });
    return (
      <Box data={{ role: 'GenericErrorSection' }}>
        <ErrorSection texts={errorLines} contactUsLink={contactUsLink} />
      </Box>
    );
  }

  const errorLines = [
    'Unfortunately, something has gone wrong at our end.',
    'Please try again later.',
  ];

  return (
    <Box data={{ role: 'GenericErrorSection' }}>
      <ErrorSection texts={errorLines} />
    </Box>
  );
};

export { GenericErrorSection };
